import React from 'react';
import { ModalBody, ModalHeader, Button } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { LoiFormsProcess } from '../../../../slices/marketplace/loi-comparison/models/loi-forms-process.model';
import { useStateSelector } from '../../../../store/selectors';
import './LoiVersionHistoryPopup.scss'
const POPUP_WIDTH = 600;

export interface LoiVersionHistoryPopupProps {
    isVisible: boolean;
    onClose: () => void;
    buyerName: string;
    processes: LoiFormsProcess[];
    onViewVersion: (loiFormId: string) => void;
    engagementId: number;
    activeLoiFormId?: string;
}

export const LoiVersionHistoryPopup = (props: LoiVersionHistoryPopupProps) => {
    const {
        isVisible,
        onClose,
        buyerName,
        processes,
        onViewVersion,
        engagementId,
        activeLoiFormId,
    } = props;
    const axios = useStateSelector((state) => state.core.axios);

    const handleView = (loiFormId: string) => {
        onViewVersion(loiFormId);
    };

    const handleOpenDocument = (documentDetailsId: string) => {
        if (!axios) return;
        axios
            .get(
                `/api/marketplace/engagements/${engagementId}/documentsDetails/${documentDetailsId}`
            )
            .then((response: { data: string }) => {
                window.open(response.data, '_blank');
            });
    };

    return (
        isVisible && (
            <div className='loi-version-history-popup'>
                <Rodal
                    visible={true}
                    animation="fade"
                    showMask={true}
                    width={POPUP_WIDTH}
                    onClose={onClose}>
                    <ModalHeader>LOI History — {buyerName}</ModalHeader>
                    <ModalBody>
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Date Completed</th>
                                    <th>LOI Document</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {processes.map((process, index) => (
                                    <tr key={process.id}>
                                        <td>{activeLoiFormId ? (process.loiFormId === activeLoiFormId ? 'Active' : index + 1) : (index === processes.length - 1 ? 'Active' : index + 1)}</td>
                                        <td>
                                            {process.completedAt
                                                ? new Date(
                                                      process.completedAt
                                                  ).toLocaleDateString()
                                                : '—'}
                                        </td>
                                        <td style={{ maxWidth: 160 }}>
                                            {process.documentDetailsId !=
                                                null &&
                                            process.documentName != null ? (
                                                <a
                                                    href="#"
                                                    title={process.documentName}
                                                    style={{
                                                        display: 'block',
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleOpenDocument(
                                                            process.documentDetailsId!
                                                        );
                                                    }}>
                                                    {process.documentName}
                                                </a>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                        <td>
                                            <Button
                                                color="primary"
                                                size="sm"
                                                onClick={() =>
                                                    handleView(
                                                        process.loiFormId
                                                    )
                                                }>
                                                View
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </ModalBody>
                </Rodal>
            </div>
        )
    );
};
